import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { RuntimeConfigService } from './runtime-config';

@Injectable({
  providedIn: 'root',
})
export class SkipRecaptchaService {
  private readonly automatedTestingEnvs = ['QA', 'TEST'];
  private readonly prequalConfig = inject(RuntimeConfigService).prequalConfig;
  private readonly activatedRoute = inject(ActivatedRoute);

  skipRecaptchaDueToTestScript(): boolean {
    const { ENV } = this.prequalConfig;
    return (
      this.automatedTestingEnvs.includes(ENV) &&
      this.activatedRoute.snapshot.queryParamMap.get('isTestScript') === 'true'
    );
  }

  skipRecaptcha(): boolean {
    const { SUPPRESS_RECAPTCHA } = this.prequalConfig;
    return (
      window.location.href.includes('localhost') ||
      SUPPRESS_RECAPTCHA ||
      this.skipRecaptchaDueToTestScript()
    );
  }
}
